"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const dashboardDisrupterVisibilityValidator_1 = require("../../helper/dashboardDisrupterVisibilityValidator");
const DisrupterStore_1 = __importDefault(require("../../stores/DisrupterStore"));
const LicenseStore_1 = __importDefault(require("../../stores/LicenseStore"));
const UiStore_1 = __importDefault(require("../../stores/UiStore"));
const DashboardDisrupterItem_1 = __importDefault(require("./DashboardDisrupterItem"));
class DashboardDisrupter extends react_1.default.Component {
    localeReactionDisposer;
    customerReactionDisposer;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            visibleItems: mobx_1.computed,
        });
    }
    get visibleItems() {
        return DisrupterStore_1.default.disrupterItems.filter(dashboardDisrupterVisibilityValidator_1.dashboardDisrupterVisibilityValidator);
    }
    componentDidMount() {
        this.localeReactionDisposer = (0, mobx_1.reaction)(() => UiStore_1.default.language, (locale) => {
            if (locale) {
                DisrupterStore_1.default.loadDisrupterItems(locale);
            }
        }, { fireImmediately: true });
        this.customerReactionDisposer = (0, mobx_1.reaction)(() => AuthorizationStore_1.default.customerId, () => {
            LicenseStore_1.default.readMassiveLicenses();
        }, { fireImmediately: true });
    }
    componentWillUnmount() {
        this.localeReactionDisposer?.();
        this.customerReactionDisposer?.();
    }
    render() {
        if (false === DisrupterStore_1.default.isLoading && 0 === this.visibleItems.length) {
            return null;
        }
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-dashboard-disrupter', {
                'znd-dashboard-disrupter--loading': DisrupterStore_1.default.isLoading,
            }) }, DisrupterStore_1.default.isLoading ? (react_1.default.createElement(LoadingSpinner_1.default, { center: true })) : (this.visibleItems.map((item) => react_1.default.createElement(DashboardDisrupterItem_1.default, { key: item.id, item: item })))));
    }
}
exports.default = (0, mobx_react_1.observer)(DashboardDisrupter);
